module.exports = __webpack_public_path__ + "media/theme/icon__recochoku-93967c9f.svg";